var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-option"},[_c('div',{staticClass:"switch-ellipse",class:{'active': _vm.checked },on:{"click":_vm.clickSwitch}},[_c('span',{staticClass:"switch-circle",class:{'active': _vm.checked }})])])}
var staticRenderFns = []

export { render, staticRenderFns }